import React, { useEffect, useState } from 'react';
import './Login.css';
import ServiceBus from '../services/ServiceBus.ts';
import { backend } from '../constants/constants.js';

import { Button } from 'primereact/button';
import { InputText } from 'primereact/inputtext';
import { FloatLabel } from 'primereact/floatlabel';

function Login() {
  useEffect(() => {
    document.body.style.backgroundColor = '#e4e4e4';
  });
  const serviceBus = new ServiceBus();
  const [user, setUser] = useState('');
  const [pass, setPass] = useState('');
  function updateUser(e) {
    setUser(e.target.value);
  }
  function updatePass(e) {
    setPass(e.target.value);
  }
  function doLogin() {
    serviceBus
      .login(user, pass)
      .then((res) => {
        serviceBus.saveToken(res['access_token']);
        window.location.replace('/lab/access');
      })
      .catch(() => {});
  }

  return (
    <>
      <div className={'login-form'}>
        <img alt="logo" className={'logo-image'} src={backend + 'logo'} />
        <br />
        {/* <label className={'username-label'}>Username:</label>
        <br />
        <br />
        <input
          className={'username-field'}
          type="text"
          value={user}
          onChange={updateUser}
        /> */}
        <div className={'repoLabelContainer'}>
          <FloatLabel>
            <InputText value={user} onChange={(e) => setUser(e.target.value)} />
            <label className={'repoLabel'}>Username</label>
          </FloatLabel>
        </div>
        <br />
        <div className={'repoLabelContainer'}>
          <FloatLabel>
            <InputText
              type="password"
              value={pass}
              onChange={(e) => setPass(e.target.value)}
            />
            <label className={'repoLabel'}>Password</label>
          </FloatLabel>
        </div>
        {/* <label className={'password-label'}>Password:</label>
        <br />
        <br />
        <input
          className={'password-field'}
          type="password"
          value={pass}
          onChange={updatePass}
        />
        <br /> */}
        <button className={'login-button'} onClick={doLogin}>
          Login
        </button>
      </div>
    </>
  );
}
export default Login;
